export default __webpack_public_path__ + "static/media/ownerDashboard.a473d56f.svg";